import { defineComponent } from "vue";

export default defineComponent({
  name: "sdk-flow-instance-starter",
  components: {
    "sdk-icon-success": () => import("../sdk-ui/sdk-icons/sdk-icon-success/sdk-icon-success.vue"),
    "sdk-icon-error": () => import("../sdk-ui/sdk-icons/sdk-icon-error/sdk-icon-error.vue"),
  },
  data() {
    return {
      businessKey: `${this.$generateId(4)}`,
      messageComponente: "",
      completed: false,
      loading: false,
    };
  },
});
